const isLocal = process.env.NODE_ENV === "development";
const SR_BASE = isLocal
  ? "http://localhost:8888/.netlify/functions/api/squadrival"
  : "https://webapp.fplnepal.com/.netlify/functions/api/squadrival";

const CACHE_PREFIX = "fplnepal_sr_v1:";
const memoryCache = new Map();

async function srJson(path, options = {}) {
  const { skipInvalidation = false, fresh = false, ...fetchOptions } = options;
  const method = String(fetchOptions.method || "GET").toUpperCase();
  const url = `${SR_BASE}${path}`;
  if (method === "GET" && !fresh) {
    const ttl = 60 * 1000;
    const now = Date.now();
    const mem = memoryCache.get(url);
    if (mem && now - mem.at < ttl) return mem.data;
    try {
      const raw = localStorage.getItem(CACHE_PREFIX + url);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && now - parsed.at < ttl) { memoryCache.set(url, parsed); return parsed.data; }
      }
    } catch (_) {}
  }
  const res = await fetch(url, fresh ? { ...fetchOptions, cache: "no-store" } : fetchOptions);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || `Request failed (${res.status})`);
  if (method === "GET" && !fresh) {
    const record = { at: Date.now(), data }; memoryCache.set(url, record);
    try { localStorage.setItem(CACHE_PREFIX + url, JSON.stringify(record)); } catch (_) {}
  } else if (method !== "GET" && !skipInvalidation) {
    memoryCache.clear();
    try { Object.keys(localStorage).filter(k => k.startsWith(CACHE_PREFIX)).forEach(k => localStorage.removeItem(k)); } catch (_) {}
  }
  return data;
}

export const fetchSquadRivalHome = () => srJson("/home", { fresh: true });
export const fetchSquadRivalSummary = () => srJson("/summary");
export const fetchSquadRivalTeams = () => srJson("/teams");
export const fetchSquadRivalTeamProfile = (squadCode) => srJson(`/team-profile/${encodeURIComponent(squadCode)}`);
export const fetchSquadRivalFixtures = ({ stage, gw } = {}) => {
  const qs = new URLSearchParams();
  if (stage) qs.set("stage", stage);
  if (gw) qs.set("gw", String(gw));
  return srJson(`/fixtures${qs.toString() ? `?${qs}` : ""}`, { fresh: true });
};
export const fetchSquadRivalStandings = (stage) => srJson(`/standings?stage=${encodeURIComponent(stage)}`, { fresh: true });
export const loginSquadRivalCaptain = (squadCode, pin) => srJson("/captain/login", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ squadCode, pin }),
});
export const saveSquadRivalCaptain = ({ squadCode, pin, captainFplId }) => srJson("/captain/select", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ squadCode, pin, captainFplId }),
});

export const fetchSquadRivalTeamDashboard = (squadCode, pin) => srJson("/team-dashboard", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ squadCode, pin }),
});

export const fetchSquadRivalChat = ({ squadCode, pin }) => srJson("/chat/messages", {
  method: "POST",
  skipInvalidation: true,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ squadCode, pin }),
});

export const sendSquadRivalChatMessage = ({ squadCode, pin, senderFplId, message }) => srJson("/chat/send", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ squadCode, pin, senderFplId, message }),
});

function adminHeaders(token) {
  return { "Content-Type": "application/json", "X-Admin-Token": token };
}
export const squadRivalAdminStatus = (token) => srJson("/admin/status", { headers: adminHeaders(token) });

export const squadRivalAdminPreviewRegistrations = (token, rows) => srJson("/admin/registrations/preview", {
  method: "POST",
  headers: adminHeaders(token),
  body: JSON.stringify({ rows }),
});
export const squadRivalAdminImportRegistrations = (token, rows) => srJson("/admin/registrations/import", {
  method: "POST",
  headers: adminHeaders(token),
  body: JSON.stringify({ rows }),
});

export const squadRivalAdminBootstrap = (token) => srJson("/admin/bootstrap", {
  method: "POST",
  headers: adminHeaders(token),
  body: JSON.stringify({}),
});
export const squadRivalAdminSyncGw = (token, gw) => srJson(`/admin/sync-gameweek/${gw}`, {
  method: "POST",
  headers: adminHeaders(token),
  body: JSON.stringify({}),
});
export const squadRivalAdminGenerateStage = (token, stageCode) => srJson(`/admin/generate-stage/${encodeURIComponent(stageCode)}`, {
  method: "POST",
  headers: adminHeaders(token),
  body: JSON.stringify({}),
});
